import { StarIc } from '@dsch/dd-icons';
import type { RatingDistributionBarProps } from '../../../../../components/PageWrappers/AdDetails/components/RatingDistributionBar/RatingDistributionBar.typed';
import * as Styled from '../../../../../components/PageWrappers/AdDetails/components/RatingDistributionBar/RatingDistributionBar.styled';
import { useTheme } from 'styled-components';

const RatingDistributionBar = (props: RatingDistributionBarProps) => {
  const {
    starNumber,
    ratingCount,
    totalRatings,
    className,
    dataTestId = 'rating-bar',
  } = props;
  const percentage = totalRatings > 0 ? (ratingCount / totalRatings) * 100 : 0;
  const theme = useTheme();

  return (
    <Styled.Container className={className} data-testid={dataTestId}>
      <Styled.RatingNumberContainer>
        <Styled.RatingNumber>{starNumber}</Styled.RatingNumber>
        <StarIc
          width={12}
          height={12}
          color={theme.colors.BLACK}
          data-testid="star"
        />
      </Styled.RatingNumberContainer>

      <Styled.ProgressBarContainer>
        <Styled.ProgressBarFill
          percentage={percentage}
          data-testid="progress-bar-fill"
        />
      </Styled.ProgressBarContainer>

      <Styled.RatingCount>{ratingCount}</Styled.RatingCount>
    </Styled.Container>
  );
};

export { RatingDistributionBar };
